// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__usHYc","left":"StickyBox_left__3Cgf9","right":"StickyBox_right__n_Zi0"};